import { render, staticRenderFns } from "./RecordingShare.vue?vue&type=template&id=5711a242&scoped=true&"
import script from "./RecordingShare.vue?vue&type=script&lang=js&"
export * from "./RecordingShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711a242",
  null
  
)

export default component.exports